import { Scenario } from '../../types';

export function cloneScenarioSnapshot(scenario: Scenario): Scenario {
  return structuredClone(scenario);
}

export function scenariosEqual(a: Scenario, b: Scenario): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function isScenarioDirty(current: Scenario, saved: Scenario | null): boolean {
  if (!saved) return true;
  return !scenariosEqual(current, saved);
}
